import useAuth from "./hooks/useAuth";
import { useEffect, useState } from "react";
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import Paginator from "../library/components/Paginator";
import Selector from "./Components/Selector";
import CheckUserStats from "./CheckUserStats";

const AccessInterface = ({ successHandler }) => {
  const { setAuth } = useAuth();
  const [users, setUsers] = useState([]);
  const [requests, setRequests] = useState([]);
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [subscribed, setSubscribed] = useState(false);
  const [accessSearch, setAccessSearch] = useState("");
  const [requestSearch, setRequestSearch] = useState("");
  const [accessPage, setAccessPage] = useState(1);
  const [requestPage, setRequestPage] = useState(1);
  const [accessPages, setAccessPages] = useState(0);
  const [requestPages, setRequestPages] = useState(0);
  const [role, setRole] = useState({ label: "All", value: "All" });
  const [changeList, setChangeList] = useState([]);
  const tabs = ['User management', "Stats"];
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [checkUser, setCheckUser] = useState();

  const updateAccessList = async (page = 1) => {
    const token = localStorage.getItem("token");
    let query = `?page=${page}`;
    if (accessSearch !== "") {
      query += `&search=${accessSearch}`;
    }
    if (role.value !== "All") {
      query += `&role=${role.value}`;
    }
    
    fetch(`${process.env.REACT_APP_USER_API_URL}/admin/access-list${query}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      if (response.ok) {
        return response.json();
      }
      if (response.status === 401) {
        localStorage.removeItem("token");
        setAuth({});
      }
    }).then(json => {
      if (json) {
        let xs = [];
        for (const user of json) {
          xs.push(user);
        }
        setUsers(xs);
      }
    });
    await getAccessPages();
  }

  const searchUsers = async (event) => {
    event.preventDefault();
    setAccessPage(1);
    await updateAccessList();
  }

  const searchRequests = async (event) => {
    event.preventDefault();
    setRequestPage(1);
    await updateRequestList();
  }

  const updateRequestList = async (page = 1) => {
    const token = localStorage.getItem("token");
    fetch(`${process.env.REACT_APP_USER_API_URL}/admin/request-list?page=${page}${requestSearch !== "" ? `&search=${requestSearch}` : ""}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }
    }).then(response => {
      if (response.ok) {
        return response.json();
      }
      if (response.status === 401) {
        localStorage.removeItem("token");
        setAuth({});
      }
    }).then(json => {
      if (json) {
        let xs = [];
        for (const request of json) {
          xs.push(request);
        }
        setRequests(xs);
      }
    });
    await getRequestPages();
  }

  const changeAccess = async (username, role) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/admin/change-access/${username}/${role}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }
    });
    if (response.status === 401) {
      localStorage.removeItem("token");
      setAuth({});
    }
  }

  const denyAccess = async (username, role) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/admin/deny-request/${username}/${role}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (response.status === 401) {
      localStorage.removeItem("token");
      setAuth({});
    }
  }

  const sendEmail = async (event) => {
    event.preventDefault();
    setEmail("");
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/admin/invite/${email}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (response.ok) {
      setEmailError("Email sent successfully");
    }
    if (response.status === 401) {
      localStorage.removeItem("token");
      setAuth({});
    }
    if (response.status === 409) {
      setEmailError("User with this email already exists");
    }
  }

  const handleCheck = async () => {
    const newState = !subscribed;
    setSubscribed(newState);
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/admin/subscribe/${newState}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }
    });
    if (response.status === 401) {
      localStorage.removeItem("token");
      setAuth({});
    }
  }

  const getAccessPages = async () => {
    const token = localStorage.getItem("token");
    let query = `?`
    if (accessSearch !== "") {
      query += `search=${accessSearch}`;
      if (role !== "All") {
        query += "&";
      }
    }
    if (role.value !== "All") {
      query += `role=${role.value}`;
    }
    if (query === "?") {
      query = "";
    } 
    fetch(`${process.env.REACT_APP_USER_API_URL}/admin/access-pages${query}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      if (response.ok) {
        return response.json();
      }
      if (response.status === 401) {
        localStorage.removeItem("token");
        setAuth({});
      }
    }).then(json => {
      if (json) {
        setAccessPages(json["pages"]);
      }
    });
  }

  const getRequestPages = async () => {
    const token = localStorage.getItem("token");
    fetch(`${process.env.REACT_APP_USER_API_URL}/admin/request-pages${requestSearch !== "" ? `?search=${requestSearch}` : ""}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      if (response.ok) {
        return response.json();
      }
      if (response.status === 401) {
        localStorage.removeItem("token");
        setAuth({});
      }
    }).then(json => {
      if (json) {
        setRequestPages(json["pages"]);
      }
    })
  }

  const deleteUser = async (username) => {
    const token = localStorage.getItem("token");
    const response = await fetch(`${process.env.REACT_APP_USER_API_URL}/admin/delete-user/${username}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    });
    if (response.status === 401) {
      localStorage.removeItem("token");
      setAuth({});
    }
  }

  const commit = async () => {
    for (const change of changeList) {
      if (change["action"] === "DELETE") {
        await deleteUser(change["username"]);
      } else if (change["action"].split(" ")[0] === "DENY") {
        await denyAccess(change["username"], change["action"].split("->")[1]);
      } else {
        await changeAccess(change["username"], change["action"].split("->")[1]);
      }
    }
    setChangeList([]);
    updateAccessList();
    updateRequestList();
    getAccessPages();
    getRequestPages();
  }

  const addChange = (change) => {
    setChangeList([...changeList, change]);
  }

  const addChangeAccess = (username, oldRole, newRole) => {
    addChange({ "username": username, "action": `${oldRole}->${newRole}` });        
  }

  const addDenyAccess = (username, oldRole, newRole) => {
    addChange({ "username": username, "action": `DENY ${oldRole}->${newRole}` });
  }

  const addDeleteUser = (username) => {
    addChange({ "username": username, "action": "DELETE" });
  }

  const removeChange = (i) => {
    let array = [...changeList];
    array.splice(i, 1);
    setChangeList(array);
  }

  const handleGoBack = () => {
    if (checkUser) {
      setCheckUser(null);
    } else {
      successHandler(false);
    }
  }

  useEffect(() => { updateAccessList() }, []);
  useEffect(() => { updateAccessList(accessPage) }, [accessPage]);
  useEffect(() => { updateRequestList() }, []);
  useEffect(() => { updateRequestList(requestPage) }, [requestPage]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    fetch(`${process.env.REACT_APP_USER_API_URL}/admin/subscribed`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      if (response.ok) {
        return response.json();
      }
      if (response.status === 401) {
        localStorage.removeItem("token");
        setAuth({});
      }
    }).then(json => {
      if (json) {
        setSubscribed(json["subscribed"]);
      }
    })
  }, []);

  useEffect(() => { setEmailError("") }, [email]);

  if (users == []) {
    return (
      <div className="flex justify-center items-center py-12">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <p className="text-gray-600 mt-2">Loading admin interface...</p>
        </div>
      </div>
    );
  }

  const options = ["USER", "CREATOR", "ADMIN"];
  const searchOptions = [
    { label: "All", value: "All" },
    { label: "USER", value: "USER" },
    { label: "CREATOR", value: "CREATOR" },
    { label: "ADMIN", value: "ADMIN" }
  ];
  
  return (
    <div className="w-full max-w-7xl mx-auto p-4 sm:p-6 lg:p-8">
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <button 
          onClick={handleGoBack}
          className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors duration-200 font-medium"
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
          {checkUser ? "Back to Stats" : "Go back to Main View"}
        </button>
        <div className="text-center flex-1">
          <h1 className="text-3xl font-bold text-blue-700">Admin Dashboard</h1>
          <p className="text-gray-600 mt-2">Manage users and view statistics</p>
        </div>
        <div className="w-40"></div> {/* Spacer for balance */}
      </div>

      {/* Tabs - Only show when not viewing individual user stats */}
      {!checkUser && (
        <Selector 
          clickHandler={(tab_index) => setActiveTabIndex(tab_index)} 
          tabsData={tabs} 
          active={activeTabIndex}
        />
      )}

      {/* User Management Tab */}
      {!checkUser && tabs[activeTabIndex] === 'User management' && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mt-6">
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-8">
            {/* User List Section */}
            <div className="space-y-6">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <h3 className="text-xl font-semibold text-gray-800">User Management</h3>
                <form onSubmit={searchUsers} className="flex gap-2">
                  <input 
                    type="text" 
                    placeholder="Search users..."
                    value={accessSearch}
                    onChange={(e) => setAccessSearch(e.target.value)}
                    className="border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <button 
                    type="submit"
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition-colors font-medium text-sm"
                  >
                    Search
                  </button>
                </form>
              </div>

              {users.length > 0 ? (
                <div className="space-y-4">
                  <Paginator 
                    maxpage={accessPages} 
                    page={accessPage}
                    clickHandler={(page) => setAccessPage(page)}
                  />
                  
                  <div className="bg-gray-50 rounded-lg border border-gray-200 overflow-hidden">
                    <div className="grid grid-cols-3 gap-4 p-4 bg-gray-100 border-b border-gray-200">
                      <div className="font-semibold text-gray-700">User</div>
                      <div className="font-semibold text-gray-700">Role</div>
                      <div className="font-semibold text-gray-700 text-center">Action</div>
                    </div>
                    {users.map((user, i) => (
                      <div key={user.username} className="grid grid-cols-3 gap-4 p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors">
                        <div className="text-gray-800 font-medium truncate">{user.username}</div>
                        <div>
                          <Dropdown 
                            options={options} 
                            onChange={(option) => addChangeAccess(user.username, user.role, option.label)} 
                            value={user.role} 
                          />
                        </div>
                        <div className="flex justify-center">
                          <button 
                            onClick={() => addDeleteUser(user.username)}
                            className="text-red-600 hover:text-red-700 font-medium text-sm bg-red-50 hover:bg-red-100 px-3 py-1 rounded-lg border border-red-200 transition-colors"
                          >
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
                  <div className="text-gray-400 text-4xl mb-2">👥</div>
                  <p className="text-gray-500">No users found matching your criteria</p>
                </div>
              )}
            </div>

            {/* Side Panel */}
            <div className="space-y-6">
              {/* Pending Changes */}
              {changeList.length > 0 && (
                <div className="bg-amber-50 rounded-lg border border-amber-200 p-4">
                  <h4 className="font-semibold text-amber-800 mb-3 flex items-center gap-2">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                    </svg>
                    Pending Changes
                  </h4>
                  <div className="space-y-2">
                    {changeList.map((change, i) => (
                      <div key={i} className="flex items-center justify-between bg-white p-3 rounded border border-amber-100">
                        <div className="flex-1">
                          <div className="font-medium text-gray-800">{change.username}</div>
                          <div className="text-sm text-gray-600">{change.action}</div>
                        </div>
                        <button 
                          onClick={() => removeChange(i)}
                          className="text-red-600 hover:text-red-700 p-1 rounded transition-colors"
                        >
                          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                  <button 
                    onClick={commit}
                    className="w-full mt-3 bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 transition-colors font-medium"
                  >
                    Commit Changes
                  </button>
                </div>
              )}

              {/* Access Requests */}
              <div className="bg-blue-50 rounded-lg border border-blue-200 p-4">
                <h4 className="font-semibold text-blue-800 mb-3 flex items-center gap-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
                  </svg>
                  Access Requests
                </h4>
                <form onSubmit={searchRequests} className="flex gap-2 mb-4">
                  <input 
                    type="text" 
                    placeholder="Search requests..."
                    value={requestSearch}
                    onChange={(e) => setRequestSearch(e.target.value)}
                    className="flex-1 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  <button 
                    type="submit"
                    className="bg-blue-500 text-white px-3 py-2 rounded-lg hover:bg-blue-600 transition-colors font-medium text-sm"
                  >
                    Search
                  </button>
                </form>

                {requests.length > 0 ? (
                  <div className="space-y-4">
                    <Paginator
                      maxpage={requestPages} 
                      page={requestPage}
                      clickHandler={(page) => setRequestPage(page)}
                    />
                    <div className="space-y-2">
                      {requests.map((request, i) => (
                        <div key={i} className="bg-white p-3 rounded border border-blue-100">
                          <div className="flex items-center justify-between">
                            <div className="flex-1">
                              <div className="font-medium text-gray-800">{request.username}</div>
                              <div className="text-sm text-gray-600">
                                Requesting: <span className="font-medium">{request.newRole}</span>
                              </div>
                            </div>
                            {request.newRole.indexOf("/") === -1 && (
                              <div className="flex gap-2">
                                <button 
                                  onClick={() => addChangeAccess(request.username, request.oldRole, request.newRole)}
                                  className="text-green-600 hover:text-green-700 font-medium text-sm bg-green-50 hover:bg-green-100 px-3 py-1 rounded border border-green-200 transition-colors"
                                >
                                  Accept
                                </button>
                                <button 
                                  onClick={() => addDenyAccess(request.username, request.oldRole, request.newRole)}
                                  className="text-red-600 hover:text-red-700 font-medium text-sm bg-red-50 hover:bg-red-100 px-3 py-1 rounded border border-red-200 transition-colors"
                                >
                                  Deny
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <div className="text-center py-4 text-gray-500">
                    No pending requests
                  </div>
                )}

                <div className="mt-4 flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={subscribed}
                    onChange={handleCheck}
                    className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                  <label className="text-sm text-gray-700">Subscribe to request notifications</label>
                </div>
              </div>

              {/* Invite User */}
              <div className="bg-teal-50 rounded-lg border border-teal-200 p-4">
                <h4 className="font-semibold text-teal-800 mb-3">Send Invitation</h4>
                <form onSubmit={sendEmail} className="space-y-3">
                  <input 
                    type="email" 
                    placeholder="email@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500"
                    required
                  />
                  {emailError && (
                    <div className={`text-sm ${emailError.includes("sent") ? "text-green-600" : "text-red-600"}`}>
                      {emailError}
                    </div>
                  )}
                  <button 
                    type="submit"
                    className="w-full bg-teal-500 text-white py-2 rounded-lg hover:bg-teal-600 transition-colors font-medium"
                  >
                    Send Invitation
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Stats Tab */}
      {!checkUser && tabs[activeTabIndex] === 'Stats' && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6 mt-6">
          <div className="space-y-6">
            <h3 className="text-xl font-semibold text-gray-800">User Statistics</h3>
            <p className="text-gray-600">Select a user to view their learning statistics and progress.</p>
            
            {users.length > 0 ? (
              <div className="space-y-4">
                <Paginator 
                  maxpage={accessPages} 
                  page={accessPage}
                  clickHandler={(page) => setAccessPage(page)}
                />
                
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                  {users.map((user, i) => (
                    <button
                      key={user.username}
                      onClick={() => setCheckUser(user.username)}
                      className="bg-white border border-gray-200 rounded-lg p-4 hover:border-blue-300 hover:shadow-md transition-all duration-200 text-left group"
                    >
                      <div className="flex items-center gap-3">
                        <div className="bg-blue-100 p-2 rounded-lg group-hover:bg-blue-200 transition-colors">
                          <svg className="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                          </svg>
                        </div>
                        <div>
                          <div className="font-semibold text-gray-800 group-hover:text-blue-700">
                            {user.username}
                          </div>
                          <div className="text-sm text-gray-500 capitalize">{user.role.toLowerCase()}</div>
                        </div>
                      </div>
                    </button>
                  ))}
                </div>
              </div>
            ) : (
              <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
                <div className="text-gray-400 text-4xl mb-2">📊</div>
                <p className="text-gray-500">No users available for statistics</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Individual User Stats View */}
{checkUser && (
  <div className="w-full mt-6">
    <CheckUserStats checkuser={checkUser} successHandler={setCheckUser} />
  </div>
)}
    </div>
  )   
}

export default AccessInterface;